import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';


export const PopupTitle = styled.span`
    display: inline-block;
    max-width: 90%;
`;

export const PopupContent = styled.div`
    flex-direction: column;
    row-gap: 16px;
`;

export const ButtonsRow = styled.div`
    gap: 12px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        & > button {
            width: 100%;
        }
    }
`;
